import { Asterisk, HelpCircle } from 'lucide-react'
import type { SchemaField } from '../../../../types/schede'

interface CheckboxFieldProps {
  field: SchemaField
  value: any
  onChange: (value: any) => void
  readOnly?: boolean
  error?: string
}

export default function CheckboxField({ field, value, onChange, readOnly, error }: CheckboxFieldProps) {
  return (
    <div className="mb-1">
      <label className="flex items-center gap-2 cursor-pointer text-sm">
        <input
          type="checkbox"
          checked={!!value}
          onChange={(e) => onChange(e.target.checked)}
          disabled={readOnly}
          className="w-4 h-4 rounded"
          style={{
            accentColor: 'var(--color-primary, #3b82f6)',
          }}
        />
        <span style={{ color: 'var(--color-text-primary)' }}>{field.label}</span>
        {field.required && <Asterisk className="w-2.5 h-2.5" style={{ color: 'var(--color-danger, #ef4444)' }} />}
        {field.help_text && (
          <span title={field.help_text} className="cursor-help">
            <HelpCircle className="w-3 h-3" style={{ color: 'var(--color-text-tertiary)' }} />
          </span>
        )}
      </label>
      {error && (
        <p className="text-[10px] mt-0.5" style={{ color: 'var(--color-danger, #ef4444)' }}>{error}</p>
      )}
    </div>
  )
}
